import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Typography } from '@material-tailwind/react';
import { useSelector } from 'react-redux';
import { ProdutoModalInfo } from '../Modal/ProdutoModalInfo';
import { overflowMui } from '../ThemeMode/stylesMui';
import TableNotFound from './TableNotFound';
import LinearProgress from '@mui/material/LinearProgress';

export default function TableHistoricSaida({ columns, rows, loading }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const { productos } = useSelector((state) => state.product);
  const [viewProduct, setViewProduct] = useState(false);

  const handleViewProduct = (produto) => {
    const view = productos.find((produt) => produt.winthor === produto.produtoWinthor);
    setViewProduct(view);
  };

  const handleCloseViewProdut = () => {
    setViewProduct(false);
  };
  useEffect(() => {
    setPage(0);
  }, [rows]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      <Paper
        sx={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        <TableContainer
          sx={{
            height: '100%',
            maxHeight: '90%',
            width: '300',
            ...overflowMui(),
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            stripedRows
            size="medium"
            sx={{ textTransform: 'uppercase' }}
          >
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell key={column.id} align={column.align}>
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan={6}>
                    <LinearProgress />
                  </TableCell>
                </TableRow>
              )}
              {rows.length === 0 && !loading && <TableNotFound colSpan={6} />}
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {columns.map((column, index) => {
                      if (column.id === 'produtoNome') {
                        return (
                          <TableCell key={index} sx={{ padding: '4px 16px', minWidth: '250px' }}>
                            <Typography
                              onClick={() => handleViewProduct(row)}
                              variant="small"
                              className="font-bold uppercase hover:underline text-black cursor-pointer "
                            >
                              {row.produtoNome}
                            </Typography>
                          </TableCell>
                        );
                      }
                      const value = row[column.id];
                      return (
                        <TableCell
                          key={column.id}
                          align="center"
                          sx={{ padding: '4px 16px', width: '5%' }}
                        >
                          <Typography
                            variant="small"
                            color="black"
                            className="font-normal whitespace-nowrap "
                          >
                            {value}
                          </Typography>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[50, 100, 150]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) =>
            `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`} resultados`
          }
          labelRowsPerPage="Por página:"
        />
      </Paper>
      <ProdutoModalInfo produto={viewProduct} handleProduto={handleCloseViewProdut} />
    </>
  );
}
